export default "__VITE_ASSET__CPaNoaKH__"